import * as React from 'react';
import { Field, WrappedFieldArrayProps } from 'redux-form';
import { II18nMessages } from '../../../../../../services/branding/models';
import { Button, Col, FormGroup, Row } from 'react-bootstrap';
import SelectControl from '../../../../../../components/SelectControl';
import FaTrash from 'react-icons/fa/trash';
import { IChannel, IDestination } from '../../../../../../data/api/models';
import { isRequired } from '../../../../../../util/validators';
import { filter } from 'lodash';

interface IDestinationOwnProps {
  i18n: II18nMessages;
  destinations: IDestination[];
  destinationsValue: string[];
  renderDefinition(name: string): any;
  channel: IChannel;
}

type IDestinationProps = IDestinationOwnProps & WrappedFieldArrayProps<any>;

class Destination extends React.Component<IDestinationProps> {
  private addField = () => {
    const { fields } = this.props;

    fields.push('');
  }

  private deleteField = (index) => () => {
    const { fields } = this.props;

    fields.remove(index);
  }

  private renderFields() {
    const { fields, destinations, destinationsValue } = this.props;

    const destinationsListFiltered = filter(destinations, (destination) => destination.included === true);

    const destinationsList = destinationsListFiltered.map((destination) => ({
      label: destination.name,
      value: destination.name,
      disabled: destinationsValue.indexOf(destination.name) > -1,
    }));

    return fields.map((destination, index) => {
      const columns = {
        first: {
          field: {
            xs: 12,
          },
          btn: {
            xs: 0,
            className: 'hidden',
          },
        },
        normal: {
          field: {
            xs: 9,
            sm: 10,
            md: 10,
            lg: 10,
          },
          btn: {
            xs: 3,
            sm: 2,
            md: 2,
            lg: 2,
          },
        },
      };
      const colConfig = columns[index === 0 ? 'first' : 'normal'];
      const margin = index === 0 ? '0px' : '10px';
      const wholeWidth = index === 0 ? '83.3%' : '100%';

      return (
        <Row key={index} style={{marginTop: margin, width: wholeWidth}}>
          <Col {...colConfig.field}>
            <Field
              name={destination}
              options={destinationsList}
              component={SelectControl}
              placeholder="Type the country here"
              validate={[isRequired]}
            />
          </Col>
          <Col {...colConfig.btn}>
            <Button bsStyle="link" onClick={this.deleteField(index)}>
              <div className="remove-icon"><FaTrash /></div>
            </Button>
          </Col>
        </Row>
      );
    });
  }

  public componentWillMount() {
    if (this.props.fields.length === 0) {
      this.addField();
    }
  }

  public render() {
    const { i18n} = this.props;

    return (
      <div>
        <Row>
          <Col sm={9}>
            <FormGroup controlId="destination">
              <Col sm={12} className="destinations-inputs">
                {this.renderFields()}
              </Col>
            </FormGroup>
          </Col>
          <Col sm={3}>
            <Button bsStyle="primary" onClick={this.addField}>
              {i18n.quote.tripDetails.addCountry}
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Destination;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/TripDetailsJourneyB/components/Destination/index.tsx